// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { NextStep, StepTarget } from '../../../bygning/overblik';
import { Panel } from '../Panel';
import styles from './Overblik.module.css';

export interface NextStepsProps {
  steps: readonly NextStep[];
  onGo: (target: StepTarget) => void;
}

/**
 * "Næste skridt" (v8 `.nx`): what waits in the case, each a jump to the mode
 * that resolves it. The badge's tone says whether it asks for action; the
 * button's name says it in words.
 */
export function NextSteps({ steps, onGo }: NextStepsProps) {
  return (
    <Panel title="Næste skridt">
      <ul className={styles.steps}>
        {steps.map((s) => (
          <li key={s.key}>
            <button type="button" className={styles.step} onClick={() => onGo(s.target)} aria-label={s.label}>
              <span className={`${styles.badge} ${styles[`badge_${s.tone}`]}`} aria-hidden="true">
                {s.badge}
              </span>
              <span className={styles.stepText}>{s.text}</span>
              <span className={styles.chev} aria-hidden="true">
                ›
              </span>
            </button>
          </li>
        ))}
      </ul>
    </Panel>
  );
}
